import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, UntypedFormControl, Validators, AbstractControl } from '@angular/forms';
import { AccessService } from '../service/access.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DatePipe } from '@angular/common';
import { QualificationsModalComponent } from '../employe-access/qualifications-modal/qualifications-modal.component';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalsConfirmAccessEmployeeContractorComponent } from '../employe-access/modals-confirm/modals-confirm.component';
import { environment } from '../../../../environments/environment';
import {CustomsValidators} from '../../validators/custom.validators'
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-access-contract',
  templateUrl: './access-contract.component.html',
  styleUrls: ['./access-contract.component.css']
})
export class AccessContractComponent implements OnInit {
  oneSapZone: string
  oneSapSite: string
  buttonEnable: boolean = true
  formAccessContractor: UntypedFormGroup;
  RadioGroup: UntypedFormGroup;
  formRadio: UntypedFormGroup;
  selectZone: any = [];
  sites: any = [];
  dataEntries: any;



  selectBusiness: any = [];
  selectSubZone: any = [];
  selectCountry: any;

  description: string = null;
  descriptionEs: string = null;
  todayDate: Date;
  maxDate: Date;
  maxDateTo: Date;
  approvers: any;
  submited = false;

  typeEmployee: string;
  contractors: any;
  requestor: any;

  radioPress = false;
  controlNationalError = false;
  controlCountryError = false;
  controlDateAddError = false;
  controlRepeatPerson = false;
  controlNotFoundError = false;
  controlPeopleInError = false;
  controlContractError = false;
  controlContractNotFound = false;
  controlSiteZoneCCError = false;
  controlContractNotExistError = false;

  controlAddDuplicate = false;


  fileName = 'false';
  fileError = false;
  excelvalid = true;
  urlExcel = environment.urlExampleFileEmployee;
  filesize = false;
  fileformat = false;
  descriptionSubzone = null

  approverFacilityZone: any;
  approverFacilitySubZone: any;

  blockAdd =false;

  //excel response data
  formTableEntry: any;
  formTableEntryInvalid: any;
  disabledItems: any;
  notValid: any;
  dateValn48 = false;

  siteCC: any;
  zoneCC: any;
  subzoneCC: any;

  options:any[];
  optionsApproverSubzone:any[];


  controlNotFoundContract = false;
  controlNotFoundPerson = false;
  optionsDocuments = [{ name: 'RUT', valueName: 'nationalId' }, { name: 'Passport', valueName: 'passportNumber' }];

  siteIdParam: string;
  zoneIdParam: string;
  subZoneIdParam: string;

  constructor(private formBuilder: UntypedFormBuilder, private dataApi: AccessService, public dialog: MatDialog,
    private spinner: NgxSpinnerService, private _snackBar: MatSnackBar, private datePipe: DatePipe,
    private router: Router, private route: ActivatedRoute
  ) {
    this.dataEntries = [];
    this.RadioGroup = new UntypedFormGroup({
      radioBtn: new UntypedFormControl()
    });
    this.approvers = [];
    this.todayDate = new Date();
    this.maxDate = new Date((this.todayDate.getFullYear() +environment.MaxYeardateAccessForms), this.todayDate.getMonth(),this.todayDate.getDate());
    this.RadioGroup.controls['radioBtn'].setValue(String("false"));
    this.siteIdParam = this.route.snapshot.queryParamMap.get('siteId');
    this.zoneIdParam = this.route.snapshot.queryParamMap.get('zoneId');
    this.subZoneIdParam = this.route.snapshot.queryParamMap.get('subZoneId');
    this.maxDateTo= new Date((this.todayDate.getFullYear() +environment.MaxYeardateAccessForms), this.todayDate.getMonth(),this.todayDate.getDate());
  }
  changeLimitDate(){

    switch(this.formAccessContractor.controls['dateIndefinite'].value){
      case true:
        let dateToSelected =new Date( this.formAccessContractor.controls['dateStart'].value)
        let dateUndefined = new Date (dateToSelected.setFullYear(dateToSelected.getFullYear()+environment.MaxYeardateAccessForms))
        this.formAccessContractor.patchValue({dateEnd: dateUndefined})
        break;
      case false:
        this.formAccessContractor.controls['dateEnd'].setValue("")
        break;
    }
  }


  ngOnInit() {
    this.formRadio = this.formBuilder.group({
      options: ['', Validators.required],
      ID: ['', [Validators.required,Validators.maxLength(10), CustomsValidators.validateRUN]],
      document: ['nationalId', Validators.required],
      countryId: ['', Validators.required],
      documentContractor: ['', Validators.required],
      documentNumberContractor: ['', [Validators.required, CustomsValidators.validateRUN]],
      nationaliyContract: ['', Validators.required]
    });
    this.formAccessContractor = this.formBuilder.group({
      siteId: ['', Validators.required],
      zoneId: ['', Validators.required],
      subZoneId: ['', Validators.required],
      bussinesUnitID: ['', Validators.required],
      accessApproverId: ['', Validators.required],
      purpuse: [''],
      contractId: ['', Validators.required],
      Confirm: [false, Validators.required],
      dateStart: ['', Validators.required],
      dateEnd: ['', Validators.required],
      facilityApproverId: [''],
      facilityPriority: [true],
      dateIndefinite: [false]
    });

    this.getEmployeeAccess();
  }
  searchContractors() {

    this.formAccessContractor.controls["contractId"].setValue('');


    if(this.formRadio.controls['documentNumberContractor'].hasError('required') ){
      return;
    }
    //validations formRadio
    this.dataEntries = [];
    this.controlNotFoundContract = false;
    this.controlNotFoundPerson = false;
    this.controlContractNotExistError = false;
    if (this.typeEmployee != "Contractor") {
      this.contractors = undefined;
    }
    this.spinner.show("loading");
    this.dataApi.getContractors(this.formRadio.value.documentContractor, this.formRadio.value.documentNumberContractor, this.formRadio.value.nationaliyContract, this.oneSapSite).subscribe((data: any) => {
      if (data === null || data === undefined) {
        this.formAccessContractor.controls['contractId'].setValue('');
        this.controlNotFoundPerson = true;
        this.spinner.hide("loading");
        return;
      }

      if(data.contracts.contracts.length==1 ){
        if(Object.entries(data.contracts.contracts[0]).length == 0){
          this.formAccessContractor.controls['contractId'].setValue('');
          this.controlNotFoundContract = true;
        }
        else{
          this.contractors = data.contracts.contracts;
        }
      }else if(data.contracts.contracts.length==0 ){
        this.formAccessContractor.controls['contractId'].setValue('');
        this.controlNotFoundContract = true;
        this.spinner.hide("loading");
        return;

      }else{
        this.contractors = data.contracts.contracts;
      }
      this.spinner.hide("loading");
    }, (err) => {
      this.spinner.hide("loading");
      if(this.controlNotFoundContract === false)
      {
        this.controlContractNotExistError = true;
      } else{
        if(err.error.error !== 'Invalid token.') {
          this.dialog.open(ModErrorComponent, {
            width: 'auto',
            panelClass: 'myapp-no-padding-dialog',
          });
        }
      }
    });
  }
  getlang(){

    return sessionStorage.getItem('lang');
  }
  getEmployeeAccess() {
    this.spinner.show("loading");
    this.dataApi.getEmployeeContractAccess().subscribe((data: any) => {
      this.spinner.hide("loading");
      this.sites = data.sites;
      this.selectBusiness = data.businessUnits;
      this.selectCountry = data.countries;
      //this.typeEmployee =data.employeeType;
      this.typeEmployee = "Employee"; //data.employeeType;
      if (this.typeEmployee === "Contractor" || data.contractors) {
        this.contractors = data.contractors;
        this.requestor = data.requestor;
      }
      if (this.siteIdParam != undefined) {
        this.formAccessContractor.controls['siteId'].setValue(this.siteIdParam);
        this.changeSelectSite(this.siteIdParam);
      }
      if (this.zoneIdParam != undefined) {
        this.formAccessContractor.controls['zoneId'].setValue(this.zoneIdParam);
        this.changeSelectZone(this.zoneIdParam);
      }
      if (this.subZoneIdParam != undefined) {
        this.RadioGroup.controls['radioBtn'].setValue('true');
        this.cleanSubzoneBU();
        this.formAccessContractor.controls['subZoneId'].setValue(this.subZoneIdParam);
        this.getApproverSubZone(this.subZoneIdParam);
      }

      if(this.zoneIdParam!=null&& this.subZoneIdParam == null){
        this.changeNotBuGetApprover(this.zoneIdParam)
      }
    }, () => {
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
    });
  }
  changeSelectSite(siteId) {
    this.ApproverId.setValue([]);
    this.approverFacilityZone = null;
    this.approverFacilitySubZone = null;
    this.formTableEntry = [];
    this.dataEntries = []
    this.formTableEntryInvalid = [];
    this.disabledItems = [];
    this.notValid = [];
    for (const siteOP of this.sites) {
      if (siteOP.id === Number(siteId)) {
        this.selectZone = siteOP.zones;
        this.siteCC = siteOP.codeCC;
        this.oneSapSite = siteOP.code1Sap;

        if (this.oneSapSite==='0000')
        {
          
          this.buttonEnable = false
         
        }
        else 
        {
          this.buttonEnable= true

        }
      }
      this.formAccessContractor.controls['zoneId'].setValue('')
      this.cleanSubzoneBU();
      this.description = null;
      this.descriptionEs = null;
    }
  }
  cleanSubzoneBU() {
    this.formTableEntry = [];
    this.dataEntries = []
    this.formTableEntryInvalid = [];
    this.disabledItems = [];
    this.notValid = [];
    this.formAccessContractor.controls['accessApproverId'].setValue('');
    this.formAccessContractor.controls['bussinesUnitID'].setValue('');
    this.formAccessContractor.controls['subZoneId'].setValue('');
    this.descriptionSubzone = null;
    this.approverFacilitySubZone = null;

  }


  changeSelectZone(zoneId) {
    this.formTableEntry = [];
    this.dataEntries = []
    this.formTableEntryInvalid = [];
    this.disabledItems = [];
    this.notValid = [];
    for (const zoneOP of this.selectZone) {
      if (zoneOP.id === Number(zoneId)) {
        if (zoneOP.subZones === undefined) {
          this.selectSubZone = [];
          this.oneSapZone = null;
        } else {
          this.selectSubZone = zoneOP.subZones;
          this.zoneCC = zoneOP.codeCC;
        }
        this.description = zoneOP.description;
        this.descriptionEs = zoneOP.descriptionEs;
        this.oneSapZone = zoneOP.code1Sap;
        if (zoneOP.facilityState) {
          this.spinner.show("loading");
          this.dataApi.getPeopleSearchByMDMID(zoneOP.approverId).subscribe(
            (response: any) => {
              this.approverFacilityZone = { //llamada al get por mdmid
                fullName: response.firstName + " " + response.lastName,
                email: response.email,
                phone: response.phoneNumber,
                priority: zoneOP.priority,
                state: zoneOP.facilityState,
                mdmid: zoneOP.approverId
              }
              this.spinner.hide("loading");
            },
            () => {
              this.spinner.hide("loading");
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',

              });
            }
          )
        } else {
          this.approverFacilityZone = null;
        }
      }
      this.cleanSubzoneBU();
    }
  }

  changeNotBuGetApprover(idZone) {
    this.ApproverId.setValue([]);
    this.formAccessContractor.controls.accessApproverId.setValue('');
    this.changeSelectZone(idZone)

    this.spinner.show("loading");
    //this.oneSapZone=idZone;
    this.dataApi.getApproversNotBu(this.oneSapSite, this.oneSapZone).subscribe((data: any) => {
      this.spinner.hide("loading");
      if (data === undefined || data === null) {
        this.approvers = [];
        this.filteredOptions = this.ApproverId.valueChanges
      } else {
        this.approvers = data;
        this.options= data;
        this.filteredOptions = this.ApproverId.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filter(name) : this.options.slice())
        );
      }
    }, () => {
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
    });
  }
    //dropdown
    ApproverId= new UntypedFormControl([Validators.required])
    // options= this.approvers;
    filteredOptions: Observable<any>;
    filteredOptionsApproverSubzone: Observable<any>;
    private _filterSubzoneApprovers(name: string): any[] {
      const filterValue = name.toLowerCase();

      return this.optionsApproverSubzone.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }
    displayFn(user: any): string {
      return user.mdmid && user.name ? user.name : '';
    }

    private _filter(name: string): any[] {
      const filterValue = name.toLowerCase();

      return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
    }

  getApproverSubZone(idSubzone) {
    this.formTableEntry = [];
    this.dataEntries = []
    this.formTableEntryInvalid = [];
    this.disabledItems = [];
    this.notValid = [];
    this.formAccessContractor.controls['accessApproverId'].setValue('');
    for (const subZoneOP of this.selectSubZone) {
      if (subZoneOP.id === Number(idSubzone)) {
        if (subZoneOP.description === undefined) {
          this.descriptionSubzone = null;
        } else {
          this.descriptionSubzone = subZoneOP.description;
          this.subzoneCC = subZoneOP.codeCC;
        }
        if (subZoneOP.facilityState) {
          this.spinner.show("loading");
          this.dataApi.getPeopleSearchByMDMID(subZoneOP.approverId).subscribe(
            (response: any) => {
              this.approverFacilitySubZone = { //llamada al get por mdmid
                fullName: response.firstName + " " + response.lastName,
                email: response.email,
                phone: response.phoneNumber,
                priority: subZoneOP.priority,
                state: subZoneOP.facilityState,
                mdmid: subZoneOP.approverId
              }
              this.spinner.hide("loading");
            },
            () => {
              this.spinner.hide("loading");
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',

              });
            }
          )
        } else {
          this.approverFacilitySubZone = null;
        }
      }
    }
    this.spinner.show("loading");
    this.dataApi.getApproverContractorSubZone(idSubzone).subscribe((data: any) => {
      this.spinner.hide("loading");
      if (data === undefined || data === null) {
        this.approvers = [];
        this.optionsApproverSubzone= [];
        this.filteredOptionsApproverSubzone = this.formAccessContractor.controls.accessApproverId.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filterSubzoneApprovers(name) : this.optionsApproverSubzone.slice())
        );
      } else {
        this.approvers = data;
        this.optionsApproverSubzone= data.sort((a, b) => a[data.name] > b[data.name] ? 1 : a[data.name] === b[data.name] ? 0 : -1);;
        this.filteredOptionsApproverSubzone = this.formAccessContractor.controls.accessApproverId.valueChanges
        .pipe(
          startWith(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filterSubzoneApprovers(name) : this.optionsApproverSubzone.slice())
        );
      }
    }, () => {
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
    });
  }



  changeBuGetApprover(idBu) {
    this.formAccessContractor.controls.accessApproverId.setValue('');
    this.spinner.show("loading");
    this.dataApi.getApproversContractor(idBu, this.oneSapSite, this.oneSapZone).subscribe((data: any) => {
      this.spinner.hide("loading");
      if (data === undefined || data === null) {
        this.approvers = [];
      } else {
        this.approvers = data;
      }
    }, () => {
      this.spinner.hide("loading");
      this.dialog.open(ModErrorComponent, {
        width: 'auto',
        panelClass: 'myapp-no-padding-dialog',

      });
    });
  }

  clearPersonDate() {
    let dateToSelected =new Date( this.formAccessContractor.controls['dateStart'].value)
    this.maxDateTo = new Date (dateToSelected.setFullYear(dateToSelected.getFullYear()+environment.MaxYeardateAccessForms))
    this.dateValn48 = false;
    this.formAccessContractor.controls['dateEnd'].setValue('')
    this.formAccessContractor.controls['dateIndefinite'].setValue(false)
    this.cleanSubFom()
  }

  transformDate(date: Date) {
    return (this.datePipe.transform(date, 'yyyy-MM-dd'));
  }



  cleanSubFom() {
    this.submited = false;
    this.formTableEntry = [];
    this.dataEntries = []
    this.formTableEntryInvalid = [];
    this.disabledItems = [];
    this.notValid = [];
    this.formRadio.controls.documentContractor.setValue('');
    this.formRadio.controls.documentNumberContractor.setValue('');
    this.formRadio.controls.nationaliyContract.setValue('');
    this.formAccessContractor.controls.contractId.setValue('');
    if (this.typeEmployee != 'Contractor') {
      this.contractors = undefined;
    }
    this.controlNotFoundContract = false;
    this.controlNotFoundPerson = false;
    this.controlPeopleInError = false;
    this.cleanBulkArrays();
    /*this.disabledItems = [];
    this.notValid = [];
    this.fileName = 'false';*/
  }



  deletePeople(i) {
    this.dataEntries.splice(i, 1);
  }
  deletePeopleBulk(i) {
    this.formTableEntry.splice(i, 1);
  }
  deletePeopleInvalidBulk(i) {
    this.formTableEntryInvalid.splice(i, 1);
  }
  deletePeopleDisabled(i) {
    this.disabledItems.splice(i, 1);
  }
  deletePeopleNotfound(i) {
    this.notValid.splice(i, 1);
  }

  seeQualifications(qualifications) {
    this.dialog.open(QualificationsModalComponent, { panelClass: 'myapp-no-padding-dialog', data: qualifications });
  }

  cleanBulkArrays() {
    this.formTableEntry = [];
    this.dataEntries = []
    this.formTableEntryInvalid = [];
    this.disabledItems = [];
    this.notValid = [];
    this.filesize = false;
    this.fileformat = false;
    this.fileName = 'false';
  }


  dateValidation(dateStart)
  {
    // validation before 48 hours
    let dateToday = new Date();
    this.dateValn48=false;
    const startDate  = new Date(this.datePipe.transform(dateStart, "MM/dd/yyyy"));
    const today  = new Date(this.datePipe.transform(dateToday, "MM/dd/yyyy"));
    let Difference_In_Days48 = (startDate.getTime() - today.getTime()) / (1000 * 3600 * 24);
    if (Difference_In_Days48 <= 2) {
      this.dateValn48 = true;
    } else {
      this.dateValn48 = false;
    }
  }


  addPerson(){
    this.spinner.show("loadPersonContract");
    this.blockAdd=false;
    if(this.typeEmployee=="Employee"){
      this.spinner.show("loadPersonContract");
      //this.radioPress = true;
      this.controlNationalError = false;
      this.controlDateAddError = false;
      this.controlRepeatPerson = false;
      this.controlNotFoundError = false;
      this.controlCountryError = false;
      this.controlContractError = false;
      this.controlContractNotFound = false;
      this.controlPeopleInError = false;
      this.controlSiteZoneCCError = false;
      if (this.formAccessContractor.controls['siteId'].hasError('required') && this.formAccessContractor.controls['zoneId'].hasError('required')
        || (this.formAccessContractor.controls['subZoneId'].hasError('required') && this.RadioGroup.value.radioBtn === 'true')
      ) {
        this.spinner.hide("loadPersonContract");
        this.controlSiteZoneCCError = true;
        return;
      }
      if (this.formAccessContractor.controls['dateStart'].hasError('required') ||
        this.formAccessContractor.controls['dateEnd'].hasError('required')) {
        this.controlDateAddError = true;
        this.spinner.hide("loadPersonContract");
        this.goTo('subzoneQ');
        return;
      }
      let contractExist = false;//CAmbiado
      for (const contract of this.contractors) {
        if (this.formAccessContractor.controls.contractId.value === contract.contractNumber) {
          if (this.formRadio.controls.documentContractor.value === 'passportNumber' ) {
            for (const contractorItem of contract.contractors) {
              if (this.formRadio.controls.documentNumberContractor.value.toLowerCase()  == ((contractorItem.passportNumber!=null)  ? contractorItem.passportNumber.toLowerCase(): null) )
              // && this.formRadio.controls['countryId'].value === contractorItem.nationality)
              {
                contractExist = true;
                break;
              }
            }
          }
          if (this.formRadio.controls.documentContractor.value === 'nationalId') {
            if (this.formRadio.value.document === 'nationalId') {
              let IdSPLIT = this.formRadio.controls.documentNumberContractor.value.split('.').join('')
              this.formRadio.controls.documentNumberContractor.setValue(IdSPLIT)
            }
            for (const contractorItem of contract.contractors) {
              if (this.formRadio.controls.documentNumberContractor.value.toLowerCase()  === ((contractorItem.nationalID!=null)  ? contractorItem.nationalID.toLowerCase(): null)) {
                contractExist = true;
                break;
              }
            }
          }
          break;
        }
      }
      if (!contractExist) {
        this.blockAdd=true;
        this.controlContractNotFound = true;
        this.spinner.hide("loadPersonContract");
        return;
      }
       const zoneId = this.formAccessContractor.value.zoneId === undefined ? 0 : Number(this.formAccessContractor.value.zoneId);
       const subzoneId = this.formAccessContractor.value.subZoneId === undefined ? 0 : Number(this.formAccessContractor.value.subZoneId);
       this.dataApi.getEmployeePeople(this.formRadio.value.documentContractor, this.formRadio.value.documentNumberContractor.toLowerCase() , this.formRadio.value.nationaliyContract,
       this.transformDate(this.formAccessContractor.value.dateStart),
       this.transformDate(this.formAccessContractor.value.dateEnd), zoneId, subzoneId).subscribe((data: any) => {
        this.spinner.hide("loadPersonContract");
            if (data.status === 3) { //notFound Code:3
             this.controlNotFoundError = true;
            } else {
              this.blockAdd=true;
              this.dataEntries.push(data)
            }
            this.blockAdd=true;

       }, (error) => {
         this.blockAdd=true;
         this.spinner.hide("loadPersonContract");
         this.dialog.open(ModErrorComponent, {
           width: 'auto',
           panelClass: 'myapp-no-padding-dialog',

         });
       });

    }

    if(this.typeEmployee=="Contractor"){
      this.spinner.show("loadPersonContract");
      //this.radioPress = true;
      this.controlNationalError = false;
      this.controlDateAddError = false;
      this.controlRepeatPerson = false;
      this.controlNotFoundError = false;
      this.controlCountryError = false;
      this.controlContractError = false;
      this.controlContractNotFound = false;
      this.controlPeopleInError = false;
      this.controlSiteZoneCCError = false;
      if (this.formAccessContractor.controls['siteId'].hasError('required') && this.formAccessContractor.controls['zoneId'].hasError('required')
        || (this.formAccessContractor.controls['subZoneId'].hasError('required') && this.RadioGroup.value.radioBtn === 'true')
      ) {
        this.spinner.hide("loadPersonContract");
        this.controlSiteZoneCCError = true;
        return;
      }
      if (this.formAccessContractor.controls['dateStart'].hasError('required') ||
        this.formAccessContractor.controls['dateEnd'].hasError('required')) {
        this.controlDateAddError = true;
        this.spinner.hide("loadPersonContract");
        this.goTo('subzoneQ');
        return;
      }

      let person={
        documentContractor:"",
        documentNumberContractor:"",
        nationaliyContract: ""
    }
    if (this.requestor.nationalId==null || this.requestor.nationalId=="" || this.requestor.nationalId==""){
        person.documentContractor = "passportNumber";
        person.documentNumberContractor= this.requestor.passportNumber;
        person.nationaliyContract = this.requestor.nationality;
    }else{
        person.documentContractor = "nationalId";
        person.documentNumberContractor= this.requestor.nationalId;

    }


      let contractExist = false;//CAmbiado
      for (const contract of this.contractors) {
        if (this.formAccessContractor.controls.contractId.value === contract.contractNumber) {



          if (person.documentContractor === 'passportNumber' ) {
            for (const contractorItem of contract.contractors) {
              if (person.documentNumberContractor.toLowerCase()  == ((contractorItem.passportNumber!=null)  ? contractorItem.passportNumber.toLowerCase(): null) )
              // && this.formRadio.controls['countryId'].value === contractorItem.nationality)
              {
                contractExist = true;
                break;
              }
            }
          }


          if (person.documentContractor === 'nationalId') { //person.documentContractor
            if (this.formRadio.value.document === 'nationalId') {
              let IdSPLIT = person.documentNumberContractor.split('.').join('')
              person.documentNumberContractor = IdSPLIT
            }
            for (const contractorItem of contract.contractors) {
              if (person.documentNumberContractor.toLowerCase()  === ((contractorItem.nationalID!=null)  ? contractorItem.nationalID.toLowerCase(): null)) {
                contractExist = true;
                break;
              }
            }
          }


          break;
        }
      }
      if (!contractExist) {
        this.blockAdd=true;
        this.controlContractNotFound = true;
        this.spinner.hide("loadPersonContract");
        return;
      }
      const zoneId = this.formAccessContractor.value.zoneId === undefined ? 0 : Number(this.formAccessContractor.value.zoneId);
      const subzoneId = this.formAccessContractor.value.subZoneId === undefined ? 0 : Number(this.formAccessContractor.value.subZoneId);
      this.dataApi.getEmployeePeople(person.documentContractor, person.documentNumberContractor.toLowerCase() , person.nationaliyContract,
      this.transformDate(this.formAccessContractor.value.dateStart),
      this.transformDate(this.formAccessContractor.value.dateEnd), zoneId, subzoneId).subscribe((data: any) => {
        if (data.status === 3) { //notFound Code:3
          this.controlNotFoundError = true;
        } else {
          this.blockAdd=true;
          this.dataEntries.push(data)
        }
        this.blockAdd=true;
        this.spinner.hide("loadPersonContract");
      }, (error) => {
        this.blockAdd=true;
        this.spinner.hide("loadPersonContract");
        this.dialog.open(ModErrorComponent, {
          width: 'auto',
          panelClass: 'myapp-no-padding-dialog',

        });
      });

    }

  }
  public toFormControl(point: AbstractControl): UntypedFormControl {
    return point as UntypedFormControl;
   }

  add() {
    this.spinner.show("loading");
    this.radioPress = true;
    this.controlNationalError = false;
    this.controlDateAddError = false;
    this.controlRepeatPerson = false;
    this.controlNotFoundError = false;
    this.controlCountryError = false;
    this.controlContractError = false;
    this.controlContractNotFound = false;
    this.controlPeopleInError = false;
    this.controlSiteZoneCCError = false;
    let doSearch = true;

    //validation contractor ingresado
    if (this.formAccessContractor.controls['siteId'].hasError('required') && this.formAccessContractor.controls['zoneId'].hasError('required')
      || (this.formAccessContractor.controls['subZoneId'].hasError('required') && this.RadioGroup.value.radioBtn === 'true')
    ) {
      this.spinner.hide("loading");
      this.controlSiteZoneCCError = true;
      return;
    }
    if (this.formAccessContractor.controls['dateStart'].hasError('required') ||
      this.formAccessContractor.controls['dateEnd'].hasError('required')) {
      this.controlDateAddError = true;
      this.spinner.hide("loading");
      this.goTo('subzoneQ');
      return;
    }

    if (this.formAccessContractor.controls.contractId.hasError('required')) {
      this.controlContractError = true;
      this.spinner.hide("loading");
      this.goTo('contractSelect');
      return;
    }
    if (this.formRadio.value.document === 'nationalId' && this.formRadio.controls['ID'].hasError('validateRUN')) {
      this.spinner.hide("loading");
      return;
    }
    if (!this.formRadio.controls['document'].hasError('required')) { //typeDocument
      if (!this.formRadio.controls['ID'].hasError('required')) {  // DocumentNumber
        if (this.formRadio.value.document === 'passportNumber' &&
          this.formRadio.controls['countryId'].hasError('required')) { //validation of nationality pending
          this.spinner.hide("loading");
          this.controlCountryError = true;
          return;
        }
        this.spinner.hide("loading");
        let contractExist = false;//CAmbiado
        for (const contract of this.contractors) {
          if (this.formAccessContractor.controls.contractId.value === contract.contractNumber) {
            if (this.formRadio.controls.document.value === 'passportNumber' ) {
              for (const contractorItem of contract.contractors) {

                if (this.formRadio.controls['ID'].value.toLowerCase()  == ((contractorItem.passportNumber!=null)  ? contractorItem.passportNumber.toLowerCase(): null) )
                // && this.formRadio.controls['countryId'].value === contractorItem.nationality)
                {
                  contractExist = true;
                  break;
                }


              }
            }
            if (this.formRadio.controls.document.value === 'nationalId') {
              if (this.formRadio.value.document === 'nationalId') {
                let IdSPLIT = this.formRadio.value.ID.split('.').join('')
                this.formRadio.controls['ID'].setValue(IdSPLIT)
              }

              for (const contractorItem of contract.contractors) {
                if (this.formRadio.controls.ID.value.toLowerCase()  === ((contractorItem.nationalID!=null)  ? contractorItem.nationalID.toLowerCase(): null)) {
                  contractExist = true;
                  break;
                }
              }
            }
            break;
          }
        }
        if (!contractExist) {
          this.controlContractNotFound = true;
          this.spinner.hide("loading");
          return;
        }
        for (const person of this.dataEntries) {
          if (person.nationalId != '' && this.formRadio.controls['document'].value=='nationalId') {
            if (String(person.nationalId).toLowerCase() == String(this.formRadio.value.ID).toLowerCase()) {
              doSearch = false;
              this.spinner.hide("loading");
              break;
            }
          } else if (person.passportNumber != '' && this.formRadio.controls['document'].value=='passportNumber') {
            if (person.passportNumber.toLowerCase() == this.formRadio.value.ID.toLowerCase() &&
              this.formRadio.controls.countryId.value.trim() == person.nationality.trim()) {
              doSearch = false;
              this.spinner.hide("loading");
              break;
            }
          }
        }
        let accessGroup = this.siteCC + '_' + this.zoneCC;
        if (this.RadioGroup.value.radioBtn == 'true') {
          accessGroup = accessGroup + '_' + this.subzoneCC;
        }
        if (doSearch) {

          const zoneId = this.formAccessContractor.value.zoneId === undefined ? 0 : Number(this.formAccessContractor.value.zoneId);
          const subzoneId = this.formAccessContractor.value.subZoneId === undefined ? 0 :
            Number(this.formAccessContractor.value.subZoneId);

          this.dataApi.getEmployeePeople(this.formRadio.value.document, this.formRadio.value.ID.toLowerCase() , this.formRadio.value.countryId,
            this.transformDate(this.formAccessContractor.value.dateStart),
            this.transformDate(this.formAccessContractor.value.dateEnd), zoneId, subzoneId).subscribe((data: any) => {
              if (data.status === 3) { //notFound Code:3
                this.controlNotFoundError = true;
              } else {

                this.dataEntries.push(data)
              }
              this.spinner.hide("loading");
            }, (error) => {
              this.spinner.hide("loading");
              this.dialog.open(ModErrorComponent, {
                width: 'auto',
                panelClass: 'myapp-no-padding-dialog',

              });
            });
        } else {
          this.spinner.hide("loading");
          this.controlRepeatPerson = true;
        }
      }else{
        this.spinner.hide("loading");
      }
      this.spinner.hide("loading");
    } else { this.spinner.hide("loading"); };


  }
  downloadExcel() {
    window.window.open(this.urlExcel);
  }

  detectFiles(event) {  //Excel --

    this.filesize = false;
    this.fileformat = false;
    this.controlSiteZoneCCError = false;
    this.controlPeopleInError = false;
    if (this.formAccessContractor.controls['siteId'].hasError('required') && this.formAccessContractor.controls['zoneId'].hasError('required')
      || (this.formAccessContractor.controls['subZoneId'].hasError('required') && this.RadioGroup.value.radioBtn === 'true')
    ) {
      this.spinner.hide("loading");
      this.controlSiteZoneCCError = true;
      return;
    }
    const FileEx = event.target.files[0];
    const names = FileEx.name.split('.')
    const formData = new FormData();
    if (this.formAccessContractor.controls['dateStart'].hasError('required') ||
      this.formAccessContractor.controls['dateEnd'].hasError('required')) {
      this.controlDateAddError = true;
      this.spinner.hide("loading");
      this.goTo('subzoneQ');
      return;
    }
    if (this.formAccessContractor.controls.contractId.hasError('required')) {
      this.controlContractError = true;
      this.spinner.hide("loading");
      this.goTo('contractSelect');
      return;
    }
    let contractorSelect;
    formData.append('file', FileEx);
    formData.append('fromDate', this.transformDate(this.formAccessContractor.controls.dateStart.value));
    formData.append('toDate', this.transformDate(this.formAccessContractor.controls.dateEnd.value));
    for (const contract of this.contractors) {
      if (this.formAccessContractor.controls.contractId.value === contract.contractNumber) {
        contractorSelect = contract.contractors;
      }
    }
    formData.append('contractors', JSON.stringify(contractorSelect));
    this.formTableEntry = [];
    this.formTableEntryInvalid = [];
    this.disabledItems = {};
    this.notValid = null;
    this.spinner.show("loading");
    if (!(FileEx.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
      names[names.length - 1].toLocaleLowerCase() === 'xlsx')
    ) {
      this.spinner.hide("loading");
      this.fileName = 'false';
      this.fileformat = true;
      event.srcElement.value = null;
      return;
    } else {
      this.fileName = FileEx.name;
      this.fileformat = false;
    }
    if (FileEx.size >= 15000000) {
      this.filesize = true;
      event.srcElement.value = null;
      this.spinner.hide("loading");
      return;
    }


    let accessGroup = this.siteCC + '_' + this.zoneCC;
    if (this.RadioGroup.value.radioBtn == 'true') {
      accessGroup = accessGroup + '_' + this.subzoneCC;
    }

    this.fileName = FileEx.name;
    const zoneId = this.formAccessContractor.value.zoneId === '' ? 0 : Number(this.formAccessContractor.value.zoneId);
    const subzoneId = this.formAccessContractor.value.subZoneId === '' ? 0 : Number(this.formAccessContractor.value.subZoneId);
    this.dataApi.ValidatePeopleExcelContractor(formData, zoneId, subzoneId).subscribe((data: any) => {
      this.formTableEntry = data.peoplesValid;
      this.formTableEntryInvalid = data.peoplesInvalid;
      this.disabledItems = data.peoplesOutContract;
      this.notValid = data.peoplesOutSar;
      this.excelvalid = true;
      event.srcElement.value = null;
      this.spinner.hide("loading");
    }, () => {
      this.excelvalid = false;
      this.spinner.hide("loading");
      // this.dialog.open(ModErrorComponent, {
      //   width: 'auto',
      //   panelClass: 'myapp-no-padding-dialog',

      // });
      event.srcElement.value = null;
    });
  }
  openDialog() {
    this.dialog.open(ModalsConfirmAccessEmployeeContractorComponent, { panelClass: 'myapp-no-padding-dialog' }).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.formAccessContractor.controls['Confirm'].setValue(true);
      }
    });
  }


  goTo(id: string) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }


  onSubmit() {
    this.submited = true;
    this.spinner.show("loading");
    this.submited = true;
    this.controlPeopleInError = false;
    if (this.formAccessContractor.controls['siteId'].hasError('required') || this.formAccessContractor.controls['zoneId'].hasError('required')) {
      this.goTo('siteSection');
      this.spinner.hide("loading");
      return;
    }
    if ((this.formAccessContractor.controls['bussinesUnitID'].hasError('required') && this.RadioGroup.value.radioBtn === false) ||
      (this.formAccessContractor.controls['subZoneId'].hasError('required') && this.RadioGroup.value.radioBtn === true)     ) {
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if (this.RadioGroup.value.radioBtn === 'false' && (this.ApproverId.value.mdmid==='' || this.ApproverId.value.mdmid===undefined || this.ApproverId.value.mdmid===null))
    {

      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if (this.RadioGroup.value.radioBtn === 'true' && (this.formAccessContractor.controls['accessApproverId'].value.mdmid==='' || this.formAccessContractor.controls['accessApproverId'].value.mdmid===undefined || this.formAccessContractor.controls['accessApproverId'].value.mdmid===null))
    {
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if (this.formAccessContractor.controls['dateStart'].hasError('required') ||
      this.formAccessContractor.controls['dateEnd'].hasError('required')) {
      this.goTo('subzoneQ');
      this.spinner.hide("loading");
      return;
    }
    if (this.formAccessContractor.controls['contractId'].hasError('required')) {
      this.goTo('radioManualBulk');
      this.spinner.hide("loading");
      return;
    }



    const AccessRequest = {
      requestorId: 1,
      siteId: Number(this.formAccessContractor.value.siteId),
      zoneId: Number(this.formAccessContractor.value.zoneId),
      subZoneId: Number(this.formAccessContractor.value.subZoneId),
      businessUnitId: String(this.formAccessContractor.value.bussinesUnitID),
      accessApproverId: this.RadioGroup.value.radioBtn === 'false' ? this.ApproverId.value.mdmid : this.formAccessContractor.value.accessApproverId.mdmid,
      purpose: this.formAccessContractor.value.purpuse,
      periodFrom: this.transformDate(this.formAccessContractor.value.dateStart),
      periodTo: this.transformDate(this.formAccessContractor.value.dateEnd),
      contractId: this.formAccessContractor.value.contractId,
      facilityApproverId: this.formAccessContractor.value.facilityApproverId,
      facilityPriority: this.formAccessContractor.value.facilityPriority,
      people: []
    };
    if (this.approverFacilityZone && this.approverFacilityZone.state && this.RadioGroup.value.radioBtn == 'false') {
      AccessRequest.facilityApproverId = this.approverFacilityZone.mdmid;
      AccessRequest.facilityPriority = this.approverFacilityZone.priority;
    } else {
      if (this.approverFacilitySubZone && this.approverFacilitySubZone.state &&
        this.RadioGroup.value.radioBtn == 'true') {
        AccessRequest.facilityApproverId = this.approverFacilitySubZone.mdmid;
        AccessRequest.facilityPriority = this.approverFacilitySubZone.priority;
      }
    }

    if (this.formRadio.value.options === 'manual') {

      if (this.formRadio.value.document === 'nationalId') {
        let IdSPLIT = this.formRadio.value.ID.split('.').join('')
        this.formRadio.controls['ID'].setValue(IdSPLIT)
      }
      for (const item of this.dataEntries) {
        if (item.status === 0 || item.status === 1) {
          AccessRequest.people.push(item.mdmid);
        }
      }
      if (AccessRequest.people.length === 0 || AccessRequest.people === null) {
        this.controlPeopleInError = true;
        this.spinner.hide("loading");
        return;
      }
      if (AccessRequest.people.length > 100) {
        this._snackBar.open('you can enter a maximum of 100 people', '', {
          duration: 3000,
        });
        return;
      }
    }

    if (this.formRadio.value.options === 'bulk') {
      for (const item of this.formTableEntry) {
        if (item.status === 0 || item.status === 1) {
          AccessRequest.people.push(item.people.mdmid);
        }
      }
      if (AccessRequest.people.length === 0 || AccessRequest.people === null) {
        this.controlPeopleInError = true;
        this.spinner.hide("loading");
        return;
      }
      if (AccessRequest.people.length > 100) {
        this._snackBar.open('you can enter a maximum of 100 people', '', {
          duration: 3000,
        });
        return;
      }
    }
    if (this.formAccessContractor.controls['Confirm'].hasError('required') ||
      this.formAccessContractor.controls['Confirm'].value === false) {
      this.spinner.hide("loading");
      return;
    }


     this.dataApi.postAccessContractor(AccessRequest).subscribe((response) => {
       this.router.navigate(['/access-confirmation/' + response.requestNumber]);
       this.spinner.hide("loading");
     }, () => {
       this.spinner.hide("loading");
     })



  }




}
